import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.27.6/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { isDragActive } from './drag/state/is-active.mjs';
import { setupGesture } from './utils/setup.mjs';

/**
 * Filter out events that are not pointer events, or are triggering
 * while a Motion gesture is active.
 */
function filterEvents(callback) {
  return function (event) {
    if (event.pointerType === "touch" || isDragActive()) return;
    callback(event);
  };
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */
function hover(elementOrSelector, onHoverStart) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _setupGesture = setupGesture(elementOrSelector, options),
    _setupGesture2 = _slicedToArray(_setupGesture, 3),
    elements = _setupGesture2[0],
    eventOptions = _setupGesture2[1],
    cancel = _setupGesture2[2];
  var onPointerEnter = filterEvents(function (enterEvent) {
    var target = enterEvent.target;
    var onHoverEnd = onHoverStart(enterEvent);
    if (typeof onHoverEnd !== "function" || !target) return;
    var onPointerLeave = filterEvents(function (leaveEvent) {
      onHoverEnd(leaveEvent);
      target.removeEventListener("pointerleave", onPointerLeave);
    });
    target.addEventListener("pointerleave", onPointerLeave, eventOptions);
  });
  elements.forEach(function (element) {
    element.addEventListener("pointerenter", onPointerEnter, eventOptions);
  });
  return cancel;
}
export { hover };